import Vue from 'vue';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

let connection = null;
let manuallyStopped = true;

const MainSignalBus = new Vue();

function createConnection({ hubUrl, getToken }) {
  connection = new HubConnectionBuilder()
    .withUrl(hubUrl, {
      withCredentials: true,
      accessTokenFactory: () => getToken?.() || '',
    })
    .configureLogging(LogLevel.None)
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: (ctx) =>
        ctx.previousRetryCount < 12000000000000 ? 1000 : null,
    })
    .build();
}

function emitIfRouteIncludes(path, event, payload) {
  if (window.location.pathname.includes(path)) {
    MainSignalBus.$emit(event, payload);
  }
}

function registerEvents() {
  connection.on('Ringing', (RingingModel) => {
    MainSignalBus.$emit('Ringing', { RingingModel });
  });

  connection.on('Up', (upModel) => {
    MainSignalBus.$emit('Up', { upModel });
  });

  connection.on('HangUp', (hangUpModel) => {
    MainSignalBus.$emit('HangUp', { hangUpModel });
  });

  connection.on('Signal', () => {
    MainSignalBus.$emit('Signal');
  });

  connection.on('MainList115', () => {
    emitIfRouteIncludes('/115/mission', 'MainList115');
  });
  //dashboard115
  connection.on('MainDashboard115', (dataMainDashboard115) => {
    // console.log("A Signal MainDashboard115 : ", dataMainDashboard115);
    emitIfRouteIncludes('/dashboards/115', 'MainDashboard115', dataMainDashboard115);
  });
  connection.on('CurrentMissionsCount', () => {
    // console.log("A Signal CurrentMissionsCount : ");
    emitIfRouteIncludes('/dashboards/115', 'CurrentMissionsCount');
    emitIfRouteIncludes('/dashboards/800', 'CurrentMissionsCount');
  });

  connection.on('VehicleReadiness', () => {
    // console.log("A Signal VehicleReadiness : ");
    emitIfRouteIncludes('/dashboards/800', 'VehicleReadiness');
  });

  connection.on('MainList800', () => {
    // console.log("SignalR2 : ", "MainList800");
    emitIfRouteIncludes('/800/mission', 'MainList800');
    emitIfRouteIncludes('/800/currentMission800', 'MainList800');
  });
  connection.on('TopList800', () => {
    // console.log("SignalR2 : ", "TopList800");
    emitIfRouteIncludes('/800/mission', 'TopList800');
    emitIfRouteIncludes('/800/newMissionWithMap800', 'TopList800');
    emitIfRouteIncludes('/dashboards/800', 'TopList800');
  });

  connection.on('MainListDoctor', () => {
    emitIfRouteIncludes('/doctor/missions', 'MainListDoctor');
  });

  connection.on('MainListAdmission', () => {
    MainSignalBus.$emit('MainListAdmission');
  });

  connection.on('MainListFollowUp', () => {
    MainSignalBus.$emit('MainListFollowUp');
  });

  connection.on('NewMission800', () => {
    MainSignalBus.$emit('NewMission800');
  });

  connection.on('HospitalList', () => {
    MainSignalBus.$emit('HospitalList');
  });

  connection.on('OutOfServiceCodes', () => {
    MainSignalBus.$emit('OutOfServiceCodes');
  });

  connection.on('WaitInHospitalList', () => {
    MainSignalBus.$emit('WaitInHospitalList');
  });

  connection.on('OutOfServiceHospital', () => {
    MainSignalBus.$emit('OutOfServiceHospital');
  });

  connection.on('CodeListFollowUp', () => {
    MainSignalBus.$emit('CodeListFollowUp');
  });

  connection.on('HospitalMainList', () => {
    MainSignalBus.$emit('HospitalMainList');
  });

  connection.on('DispatchNotification', () => {
    // console.log('[SignalR2] DispatchNotification');
  });

  connection.on('Termine', () => {
    MainSignalBus.$emit('Termine');
  });

  connection.on('Location', (data) => {
    // console.log(' SignalR2 Location 2');
    MainSignalBus.$emit('Location', { data });
  });
}

async function start(router) {
  if (!connection || !manuallyStopped) return;

  if (router?.currentRoute?.name === 'login') return;

  manuallyStopped = false;

  try {
    await connection.start();
    // console.log('[SignalR2] connected');
  } catch (err) {
    if (err?.statusCode === 401) {
      stop();
      return;
    }
    setTimeout(() => start(router), 3000);
  }
}

function stop() {
  manuallyStopped = true;
  if (connection?.state === 'Connected') {
    connection.stop();
  }
}

function attachEnvironmentListeners(router) {
  window.addEventListener('online', () => start(router));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      start(router);
    }
  });
}

export default {
  install(Vue, options) {
    if (!options?.hubUrl) {
      throw new Error('[SignalR2 Plugin] hubUrl is required');
    }

    createConnection({
      hubUrl: options.hubUrl,
      getToken: options.getToken,
    });

    registerEvents();
    attachEnvironmentListeners(options.router);

    Vue.prototype.$mainSignalr = {
      start: () => start(options.router),
      stop,
      bus: MainSignalBus,
      connection,
    };
  },
};
